<template>
    <div>
        <p v-if="!dataLoaded">Loading...</p>

        <BaseList
            v-if="dataLoaded"
            search-placeholder="Search by project name..."
            :filtered-count="filteredProjects.length"
            :total-count="projects.length"
            :current-page="currentPage"
            :items-per-page-prop="itemsPerPage"
            @search="handleSearch"
            @page-change="changePage"
            @items-per-page-change="handleItemsPerPageChange"
        >
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Customer</th>
                        <th>Rating</th>
                        <th>Sales State</th>
                        <th>Created</th>
                        <th>Address</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="project in paginatedProjects" :key="project.id">
                        <td><router-link :to="'/projects/'+project.id">{{project.name}}</router-link></td>
                        <td>{{project.customer}}</td>
                        <td>{{project.rating}}</td>
                        <td>{{project.salesstage}}</td>
                        <td>{{project.created | date}}</td>
                        <td>{{project.address1}} {{project.address2}}, {{project.locality}}, {{project.province}} {{project.country}} {{project.postcode}}</td>
                    </tr>
                </tbody>
            </table>
        </BaseList>
    </div>
</template>

<script>
    import {CallApi} from '../Utilities.js'
    import BaseList from './BaseList.vue'

    export default {
        name: 'ProjectList',
        components: {
            BaseList
        },
        data: function() {
            return {
                dataLoaded: false,
                projects: [],
                filteredProjects: [],
                currentPage: 1,
                itemsPerPage: 50
            }
        },
        computed: {
            paginatedProjects: function() {
                const start = (this.currentPage - 1) * this.itemsPerPage;
                const end = start + this.itemsPerPage;
                return this.filteredProjects.slice(start, end);
            }
        },
        methods: {
            fuzzyMatch: function(searchText, targetText) {
                const search = searchText.toLowerCase().trim();
                const target = targetText.toLowerCase();

                if (!search) return true;

                const searchTerms = search.split(/\s+/).map(term => {
                    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    return `(?:^|[^a-z0-9])${escaped}`;
                });

                const pattern = searchTerms.map(term => `(?=.*${term})`).join('');
                const regex = new RegExp(pattern);

                return regex.test(target);
            },
            handleSearch: function(searchText) {
                if (!searchText) {
                    this.filteredProjects = this.projects;
                } else {
                    this.filteredProjects = this.projects.filter(project => {
                        return this.fuzzyMatch(searchText, project.name || '');
                    });
                }
                this.currentPage = 1;
            },
            changePage: function(newPage) {
                this.currentPage = newPage;
            },
            handleItemsPerPageChange: function(newValue) {
                this.itemsPerPage = newValue;
                this.currentPage = 1;
            },
            fetchData: async function() {
                this.projects = (await CallApi('GET', '/projects')).projects
                this.filteredProjects = this.projects;
                this.dataLoaded = true
            }
        },
        mounted: function () {
            this.fetchData()
        }
    }
</script>
